import React from 'react';

import { cymbioColors } from '../../../utils/colors';
import { graphCurrencyFormatter, graphNumberFormatter } from '../utils';
import { getTextsHeight, getTotalValueByModel } from './best-sellers.utils';

export function BestSellersTotals(isGmvMetric, currency) {
  return (canvasContext) => {
    const totalsByModel = getTotalValueByModel(canvasContext.bars);
    const sortedModelsByTotals = Object.keys(totalsByModel).sort(
      (modelA, modelB) => totalsByModel[modelA] - totalsByModel[modelB],
    );

    const barHeight = canvasContext.bars[0].height;
    const yPositions = canvasContext.bars.map((bar) => bar.y);

    return (
      <g x={0} y={18} height={300} width={60} transform={`translate(${canvasContext.innerWidth} 0)`}>
        {sortedModelsByTotals.map((model, index) => {
          const value = totalsByModel[model];
          const yPosition = yPositions[index];
          const [textHeight] = getTextsHeight(barHeight, 1);

          return (
            <g key={model}>
              <rect x={0} y={yPosition} height={barHeight} width={60} fill="#f6f6f6" />
              <text
                x={4}
                y={yPosition + textHeight}
                height={barHeight}
                fill={cymbioColors.analytics.totalBlack}
                opacity={0.5}
                fontWeight={700}
                fontFamily="Nunito, sans-serif"
                fontSize={10}
                width={60}
              >
                {isGmvMetric ? graphCurrencyFormatter(value, currency) : graphNumberFormatter(value)}
              </text>
            </g>
          );
        })}
      </g>
    );
  };
}
